import Rx from 'rxjs/Rx';

import { makeCustomerProducts } from '@shared/models/customer-product.model';
import { makeProducts } from '@shared/models/product.model';
import { makeCustomerProduct } from '@api/models/customer-product.model';

class PeerToPeerStore {
  constructor(TransactionApiService, SessionService) {
    'ngInject';

    this.TransactionApiService = TransactionApiService;
    this.SessionService = SessionService;
  }

  /**
   * @returns {Observable}
   */
  getDetails() {
    return Rx.Observable.fromPromise(this.TransactionApiService.p2pTransferDetails()).map((details) => {
      let customerProducts = details.customerProducts.map(payload => makeCustomerProduct(payload));

      return {
        customerProducts: customerProducts,
        products: makeProducts(details.products),
      };
    });
  }

  getCustomerProducts() {
    return Rx.Observable.fromPromise(this.TransactionApiService.p2pTransferDetails())
    .map(details => makeCustomerProducts(details.customerProducts))
    ;
  }

  /**
   * @returns {Observable}
   */
  getCurrency() {
    return this.SessionService.session.map(session => session ? session.currency : null);
  }

  p2pTransfer(payload) {
    return this.TransactionApiService.p2pTransfer(payload);
  }
}

export default PeerToPeerStore;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/service/peertopeer.store.js